import React, { useEffect, useState } from 'react';
import { getRentalStats, RentalStats } from '../../common/Rest/Services/BookService';
import { rentalCountText } from '../../common/Utils/Utils';
import './HomePageBanner.css';

const STEPS = ['Обираєте книжку', 'отримуєте лінк на банку', 'читаєте', 'повертаєте за наш рахунок'];

const HomePageBanner: React.FC = () => {
  const [stats, setStats] = useState<RentalStats | null>(null);

  useEffect(() => {
    getRentalStats().then(setStats).catch(() => setStats(null));
  }, []);

  return (
    <section className="homepage-banner">
      <h1>Вигідна оренда книг за донат</h1>
      <div className="homepage-banner-text default-container">
        <p className="homepage-banner-lead">
          {stats && stats.totalRentals > 0 ? (
            <>
              Вже <strong>{rentalCountText(stats.totalRentals)}</strong> — і всі гроші пішли на FPV-дрони для ЗСУ.
            </>
          ) : (
            'Усі гроші з оренди йдуть на FPV-дрони для ЗСУ.'
          )}
        </p>
        <p className="homepage-steps">
          {STEPS.map((step, index) => (
            <React.Fragment key={step}>
              {index > 0 && <span className="homepage-steps-arrow" aria-hidden="true"> → </span>}
              <span>{step}</span>
            </React.Fragment>
          ))}
        </p>
      </div>
    </section>
  );
};

export default HomePageBanner;
